module.exports = __webpack_public_path__ + "img/logo_IAM.708918d8.png";